<template>
  <BaseFileViewer
    v-if="document"
    :title="document.title"
    :file-url="url"
    :type="extension"
    :dialog="true"
    @input="onClose"
  />
</template>

<script>
import BaseFileViewer from '@/components/base/BaseFileViewer';
import httpClient from '@/api/http-client';
import documentService from '@/api/document-service';
import { mapState } from 'vuex';

export default {
  name: 'ViewOrderPartDocument',

  components: { BaseFileViewer },

  data() {
    return {
      url: '',
      document: null,
    };
  },

  computed: {
    ...mapState('orderParts', ['orderParts']),

    extension() {
      return this.document?.file_name.split('.').pop();
    },
  },

  async created() {
    this.document = await this.fetchDocument(this.$route.params.id, this.$route.params.documentId);
    this.getFileUrl(this.document?.file_url);
  },

  methods: {
    getFileUrl(url) {
      httpClient({
        url,
        method: 'GET',
        responseType: 'blob',
      }).then((res) => {
        const blob =
          this.extension.toLowerCase() === 'pdf'
            ? new Blob([res.data], { type: 'application/pdf' })
            : new Blob([res.data]);
        this.url = window.URL.createObjectURL(blob);
      });
    },

    fetchDocument(orderPartId, documentId) {
      let document = null;
      for (let i = 0; i < this.orderParts.length; i++) {
        if (this.orderParts[i].id === orderPartId) {
          for (let j = 0; j < this.orderParts[i].documents.length; j++) {
            if (this.orderParts[i].documents[j].id === documentId) {
              document = this.orderParts[i].documents[j];
            }
          }
        }
      }
      if (document) {
        return Promise.resolve(document);
      }
      // eslint-disable-next-line arrow-body-style
      return documentService.getById(documentId).then((res) => {
        return res.data;
      });
    },

    onClose(event) {
      if (!event) {
        this.$emit('preview:close');
      }
    },
  },
};
</script>

<style scoped></style>
